import { APP_BASE_PATH } from '../../../common/constants'

const TITLE = 'Get the facts about Freedom Debt Relief | Freedom Debt Relief'
const DESCRIPTION =
  'More than 1 million people have turned to Freedom Debt Relief for help resolving their debt for less than they owe.'
const URL = `${APP_BASE_PATH()}/facts/`

export const SEO = {
  title: TITLE,
  description: DESCRIPTION,
  canonical: URL,
  openGraph: {
    title: TITLE,
    description: DESCRIPTION,
    url: URL,
    locale: 'en_US',
    type: 'article',
    article: {
      modifiedTime: '2025-01-09T23:13:54+00:00',
      authors: ['https://www.facebook.com/freedomdebtrelief'],
    },
  },
}

// Facts page now uses FACTS_PAGE_ORGANIZATION_SCHEMA directly in the component
// for proper schema separation between Organization and WebPage schemas
